import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "py-16 md:py-24 bg-slate-50/40" }
const _hoisted_3 = { class: "max-w-7xl mx-auto px-6 lg:px-10 xl:px-14" }
const _hoisted_4 = { class: "grid lg:grid-cols-12 gap-10 lg:gap-16 items-start" }
const _hoisted_5 = { class: "lg:col-span-6 space-y-8 lg:pr-6 order-2 lg:order-1" }
const _hoisted_6 = {
  key: 0,
  class: "space-y-8"
}
const _hoisted_7 = {
  key: 1,
  class: "space-y-8"
}
const _hoisted_8 = {
  key: 2,
  class: "space-y-8"
}
const _hoisted_9 = { class: "lg:col-span-6 w-full order-1 lg:order-2" }
const _hoisted_10 = { class: "rounded-2xl bg-white/80 supports-[backdrop-filter]:backdrop-blur-md shadow-xl ring-1 ring-black/5 p-6 md:p-10" }
const _hoisted_11 = { class: "mb-8" }
const _hoisted_12 = { class: "text-slate-900 text-2xl md:text-3xl font-semibold tracking-tight" }
const _hoisted_13 = { class: "space-y-10" }
const _hoisted_14 = { class: "grid md:grid-cols-2 gap-5 md:gap-6" }
const _hoisted_15 = { class: "col-span-2 md:col-span-1" }
const _hoisted_16 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_17 = { class: "col-span-2 md:col-span-1" }
const _hoisted_18 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_19 = {
  key: 0,
  class: "col-span-2 md:col-span-1"
}
const _hoisted_20 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_21 = {
  key: 1,
  class: "col-span-2 md:col-span-1"
}
const _hoisted_22 = { class: "relative w-full" }
const _hoisted_23 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_24 = {
  key: 2,
  class: "col-span-2 md:col-span-1"
}
const _hoisted_25 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_26 = {
  key: 3,
  class: "col-span-2 md:col-span-1"
}
const _hoisted_27 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_28 = {
  key: 4,
  class: "col-span-2"
}
const _hoisted_29 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_30 = {
  key: 5,
  class: "col-span-2"
}
const _hoisted_31 = { class: "field-wrap border-slate-200" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "grid md:grid-cols-2 gap-5 md:gap-6" }
const _hoisted_34 = { class: "col-span-2 md:col-span-1" }
const _hoisted_35 = ["type"]
const _hoisted_36 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_37 = { class: "col-span-2 md:col-span-1" }
const _hoisted_38 = ["type"]
const _hoisted_39 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_40 = { class: "space-y-4" }
const _hoisted_41 = { class: "flex flex-col md:flex-row md:items-center gap-3 md:gap-4" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 1,
  class: "inline-flex items-center gap-2"
}
const _hoisted_45 = { class: "flex flex-col justify-end gap-2" }
const _hoisted_46 = {
  key: 0,
  class: "error-msg ml-auto"
}
const _hoisted_47 = {
  key: 0,
  class: "text-center text-slate-500 text-sm mt-5"
}
const _hoisted_48 = { key: 1 }

import { onMounted, ref, computed, toRef } from 'vue'
import TopBanner from '@/components/TopBanner.vue'
import CountrySearchablePhoneField from '@/components/CountrySearchablePhoneField.vue'
import { handleApiError, isValidEmail, loadScript } from '@/utils/common'
import Auth from '@/composables/Auth'
import { NotificationType } from '@/types'
import Notification from '@/widgets/Notification.vue'
// @ts-ignore
import $ from 'jquery'


export default /*@__PURE__*/_defineComponent({
  __name: 'Signup',
  props: {
    type: {}
  },
  setup(__props: any) {

const props = __props
const type = toRef(props, 'type')              // <- expose `type` for the template

// const { registerSupplier, registerAgent, registerUser }  = Auth()

const isLoading = ref(false)
const invalidType = ref(false)
const recaptchaError = ref<any>(null)
const passwordFieldtype = ref<'password' | 'text'>('password')
const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: ''})

const pageHeading = computed(() => {
  if (type.value === 'agent') return 'Create Your Agency Account'
  if (type.value === 'web' || type.value === 'corporate') return 'Create Your Account'
  if (type.value === 'supplier') return 'Create Your Supplier Account'
  return 'Signup'
})

const form = ref<any>({
  fullName: { value: '', error: false, errorMessage: '' },
  companyName: { value: '', error: false, errorMessage: '' },
  email: { value: '', error: false, errorMessage: '' },
  phone: { value: '', error: false, errorMessage: '' },
  password: { value: '', error: false, errorMessage: '' },
  passwordConfirmation: { value: '', error: false, errorMessage: '' },
  message: { value: '', error: false, errorMessage: '' },
  crNumber: { value: '', error: false, errorMessage: '' },
  vat: { value: '', error: false, errorMessage: '' },
  address: { value: '', error: false, errorMessage: '' },
})

const togglePasswordFieldType = () => {
  passwordFieldtype.value = passwordFieldtype.value === 'password' ? 'text' : 'password'
}

const handlePhoneInput = (input: any) => {
  if (input === false) {
    form.value.phone.value = ''
    form.value.phone.error = true
    form.value.phone.errorMessage = 'Phone is required'
  } else {
    form.value.phone.value = input
    form.value.phone.error = false
  }
}

const validateForm = (): boolean => {
  let error = false
  const recaptcha = $('textarea[name="g-recaptcha-response"]')

  if (!recaptcha.length || recaptcha.val() == '' || !recaptcha.val()) {
    error = true
    recaptchaError.value = 'Please validate the recaptcha'
  } else {
    recaptchaError.value = null
  }

  if (form.value.fullName.value === '') {
    form.value.fullName.error = true
    form.value.fullName.errorMessage = 'Full name is required'
    error = true
  }

  if (form.value.email.value === '') {
    form.value.email.error = true
    form.value.email.errorMessage = 'Email is required'
    error = true
  } else if (!isValidEmail(form.value.email.value)) {
    form.value.email.error = true
    form.value.email.errorMessage = 'Email is invalid'
    error = true
  }

  if (type.value !== 'web') {
    if (form.value.phone.value === '') {
      form.value.phone.error = true
      form.value.phone.errorMessage = 'Phone number is required'
      error = true
    } else if (form.value.phone.value.length < 11) {
      form.value.phone.error = true
      form.value.phone.errorMessage = 'Phone number is invalid'
      error = true
    }

    if (form.value.companyName.value === '') {
      form.value.companyName.error = true
      form.value.companyName.errorMessage = 'Company name is required'
      error = true
    }
  }

  if (type.value !== 'supplier') {
    if (form.value.password.value === '') {
      form.value.password.error = true
      form.value.password.errorMessage = 'Password is required'
      error = true
    } else if (form.value.password.value.length < 6) {
      form.value.password.error = true
      form.value.password.errorMessage = 'Password must be at least 6 characters long'
      error = true
    }

    if (form.value.passwordConfirmation.value === '') {
      form.value.passwordConfirmation.error = true
      form.value.passwordConfirmation.errorMessage = 'Password confirmation is required'
      error = true
    } else if (form.value.passwordConfirmation.value !== form.value.password.value) {
      form.value.password.error = true
      form.value.passwordConfirmation.error = true
      form.value.password.errorMessage = 'Password does not match with password confirmation'
      error = true
    }
  }

  if (type.value === 'agent') {
    if (form.value.crNumber.value === '') {
      form.value.crNumber.error = true
      form.value.crNumber.errorMessage = 'CR Number is required'
      error = true
    }
    if (form.value.address.value === '') {
      form.value.address.error = true
      form.value.address.errorMessage = 'Address is required'
      error = true
    }
  }

  return error
}

const resetFormErrors = () => {
  Object.keys(form.value).forEach((key: string) => {
    form.value[key].error = false
    form.value[key].errorMessage = ''
  })
}

const resetForm = () => {
  Object.keys(form.value).forEach((key: string) => {
    form.value[key].value = ''
  })
}

const { registerSupplier, registerAgent, registerAgentRequest, registerUser }  = Auth()

const handleSignup = async () => {
  resetFormErrors()
  const error = validateForm()
  if (error || isLoading.value) return

  isLoading.value = true
  const recaptcha = $('textarea[name="g-recaptcha-response"]').val()
  const origin = window.location.origin

  try {
    let response: any

    if (type.value === 'supplier') {
      response = await registerSupplier(
        form.value.fullName.value,
        form.value.companyName.value,
        form.value.email.value,
        form.value.phone.value,
        form.value.message.value,
        recaptcha
      )
    } else if (type.value === 'agent') {
      response = await registerAgentRequest({
        name: form.value.fullName.value,
        email: form.value.email.value,
        password: form.value.password.value,
        passwordConfirmation: form.value.passwordConfirmation.value,
        phoneNumber: form.value.phone.value,
        crNumber: form.value.crNumber.value,
        address: form.value.address.value,
        vatNumber: form.value.vat.value || null,
        companyName: form.value.companyName.value || '',
        type: 'agent',
        origin,
        recaptcha
      })
    } else {
      response = await registerUser(
        form.value.fullName.value,
        form.value.email.value,
        form.value.phone.value,
        form.value.companyName.value,
        form.value.password.value,
        form.value.passwordConfirmation.value,
        type.value,
        recaptcha
      )
    }

    if (response.status === 201) {
      let messageDetails = ''
      if (type.value === 'supplier') {
        messageDetails = 'We have notified our support team. You will hear from us soon'
      } else if (type.value === 'agent') {
        messageDetails = 'Your Travel Agency registration has been submitted and is pending administrative review. You will receive an email once approved.'
      } else {
        messageDetails = 'You have created an account with us. Please check your email to activate your account'
      }
      notif.value = { show: true, type: 'success', message: 'Success', messageDetails }
      setTimeout(() => { notifClosed() }, 5000)
      resetForm()
    } else {
      const err = handleApiError(response)
      notif.value = { show: true, type: 'error', message: err, messageDetails: '' }
    }
  } finally {
    isLoading.value = false
  }
}

const notifClosed = () => { notif.value.show = false }

onMounted(() => {
  const recaptchaScriptUrl = 'https://www.google.com/recaptcha/api.js'
  $('.google-recaptcha').html('<div class="g-recaptcha" data-sitekey="6LdgLVspAAAAAH4Y109CAIfw26hm_onZFQsycv1v"></div>')
  loadScript(recaptchaScriptUrl, function () {})

  if (type.value !== 'agent' && type.value !== 'supplier' && type.value !== 'web') {
    invalidType.value = true
    notif.value.show = true
  }
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (!invalidType.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TopBanner, {
          layout: "full-width",
          currentPage: "Signup",
          heading: pageHeading.value,
          bannerClass: "banner-auth"
        }, null, 8, ["heading"]),
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (type.value === 'supplier')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[10] || (_cache[10] = [
                      _createStaticVNode("<div data-v-8719482a><span class=\"inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-bold bg-green-50 text-green-700 border border-green-200/50 uppercase tracking-widest\" data-v-8719482a> Chauffeur &amp; Fleet Partners </span><h2 class=\"text-3xl md:text-4xl font-extrabold text-slate-900 mt-4 leading-tight\" data-v-8719482a> Tie Up With Us &amp; Grow Your Fleet Bookings </h2><p class=\"text-slate-600 mt-4 text-[16px] leading-relaxed\" data-v-8719482a> Vehitra World is a premium global ground transportation network. We partner with local, professional transport operators and car rental suppliers to deliver top-tier airport transfers and hourly travel services to global travelers. </p></div><div class=\"space-y-6\" data-v-8719482a><h3 class=\"text-xs uppercase tracking-[0.2em] font-bold text-slate-400\" data-v-8719482a>Why Partner With Us</h3><div class=\"flex gap-4\" data-v-8719482a><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-green-50 text-green-700 flex items-center justify-center border border-green-100 shadow-sm\" data-v-8719482a><i class=\"pi pi-chart-line text-lg\" data-v-8719482a></i></div><div data-v-8719482a><h4 class=\"text-[16px] font-bold text-slate-800\" data-v-8719482a>Maximize Fleet Utilization</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\" data-v-8719482a>Receive steady corporate transfer bookings, long-distance journeys, and hourly requests to fill empty leg runs.</p></div></div><div class=\"flex gap-4\" data-v-8719482a><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-green-50 text-green-700 flex items-center justify-center border border-green-100 shadow-sm\" data-v-8719482a><i class=\"pi pi-globe text-lg\" data-v-8719482a></i></div><div data-v-8719482a><h4 class=\"text-[16px] font-bold text-slate-800\" data-v-8719482a>Global Sales Reach</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\" data-v-8719482a>Instantly gain bookings from our international agency partners and B2B corporate dashboard network.</p></div></div><div class=\"flex gap-4\" data-v-8719482a><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-green-50 text-green-700 flex items-center justify-center border border-green-100 shadow-sm\" data-v-8719482a><i class=\"pi pi-wallet text-lg\" data-v-8719482a></i></div><div data-v-8719482a><h4 class=\"text-[16px] font-bold text-slate-800\" data-v-8719482a>Transparent Settlements</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\" data-v-8719482a>Get paid on time with direct bank transfers, consolidated monthly Statement of Account (SOA) reporting, and clear ledger entries.</p></div></div></div><div class=\"bg-white border border-gray-150 rounded-2xl p-6 shadow-sm space-y-4\" data-v-8719482a><h3 class=\"text-sm uppercase tracking-wider font-bold text-slate-850\" data-v-8719482a>Onboarding Process</h3><ol class=\"relative border-l border-emerald-100 ml-3 space-y-4 text-sm text-slate-600\" data-v-8719482a><li class=\"pl-4 relative\" data-v-8719482a><span class=\"absolute -left-[5px] top-1.5 h-2 w-2 rounded-full bg-emerald-500\" data-v-8719482a></span><strong data-v-8719482a>Submit Proposal Form:</strong> Share details of your vehicle categories and message. </li><li class=\"pl-4 relative\" data-v-8719482a><span class=\"absolute -left-[5px] top-1.5 h-2 w-2 rounded-full bg-emerald-500\" data-v-8719482a></span><strong data-v-8719482a>Fleet &amp; Service Review:</strong> Our operations team reviews your fleet size, age, and insurance details. </li><li class=\"pl-4 relative\" data-v-8719482a><span class=\"absolute -left-[5px] top-1.5 h-2 w-2 rounded-full bg-emerald-500\" data-v-8719482a></span><strong data-v-8719482a>Integration &amp; Rates Setup:</strong> Upload your rates, verify details on the partner panel, and start accepting jobs. </li></ol></div>", 3)
                    ])))
                  : _createCommentVNode("", true),
                (type.value === 'agent')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[11] || (_cache[11] = [
                      _createStaticVNode("<div data-v-8719482a><span class=\"inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-bold bg-emerald-50 text-emerald-700 border border-emerald-200/50 uppercase tracking-widest\" data-v-8719482a> Travel Agency Partner </span><h2 class=\"text-3xl md:text-4xl font-extrabold text-slate-900 mt-4 leading-tight\" data-v-8719482a> Grow Your Travel Agency Margins &amp; Booking Reach </h2><p class=\"text-slate-600 mt-4 text-[16px] leading-relaxed\" data-v-8719482a> Partner with Vehitra World to access our premium global ground transportation inventory. Manage bookings, set commissions/markups, earn loyalty points, and service clients with premium airport transfers and chauffeur services globally. </p></div><div class=\"space-y-6\" data-v-8719482a><h3 class=\"text-xs uppercase tracking-[0.2em] font-bold text-slate-400\" data-v-8719482a>Agency Benefits</h3><div class=\"flex gap-4\" data-v-8719482a><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-emerald-50 text-emerald-700 flex items-center justify-center border border-emerald-100 shadow-sm\" data-v-8719482a><i class=\"pi pi-globe text-lg\" data-v-8719482a></i></div><div data-v-8719482a><h4 class=\"text-[16px] font-bold text-slate-800\" data-v-8719482a>Global Service Network</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\" data-v-8719482a>Instantly book airport transfers, hourly rentals, and point-to-point chauffeur rides in over 100+ countries.</p></div></div><div class=\"flex gap-4\" data-v-8719482a><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-emerald-50 text-emerald-700 flex items-center justify-center border border-emerald-100 shadow-sm\" data-v-8719482a><i class=\"pi pi-gift text-lg\" data-v-8719482a></i></div><div data-v-8719482a><h4 class=\"text-[16px] font-bold text-slate-800\" data-v-8719482a>Earn Loyalty Points &amp; Markups</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\" data-v-8719482a>Accumulate loyalty points on every confirmed trip and redeem points directly as credits in your agency wallet.</p></div></div><div class=\"flex gap-4\" data-v-8719482a><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-emerald-50 text-emerald-700 flex items-center justify-center border border-emerald-100 shadow-sm\" data-v-8719482a><i class=\"pi pi-users text-lg\" data-v-8719482a></i></div><div data-v-8719482a><h4 class=\"text-[16px] font-bold text-slate-800\" data-v-8719482a>Sub-Agent &amp; Staff Control</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\" data-v-8719482a>Create and manage accounts for your sub-agents, monitor bookings, set customized rights, and view performance charts.</p></div></div></div><div class=\"bg-white border border-gray-150 rounded-2xl p-6 shadow-sm space-y-4\" data-v-8719482a><h3 class=\"text-sm uppercase tracking-wider font-bold text-slate-850\" data-v-8719482a>Onboarding Process</h3><ol class=\"relative border-l border-emerald-100 ml-3 space-y-4 text-sm text-slate-600\" data-v-8719482a><li class=\"pl-4 relative\" data-v-8719482a><span class=\"absolute -left-[5px] top-1.5 h-2 w-2 rounded-full bg-emerald-500\" data-v-8719482a></span><strong data-v-8719482a>Register Your Agency:</strong> Complete the signup form with CR number and company details. </li><li class=\"pl-4 relative\" data-v-8719482a><span class=\"absolute -left-[5px] top-1.5 h-2 w-2 rounded-full bg-emerald-500\" data-v-8719482a></span><strong data-v-8719482a>Account Activation:</strong> Our partnerships team verifies and activates your B2B account within 24 hours. </li><li class=\"pl-4 relative\" data-v-8719482a><span class=\"absolute -left-[5px] top-1.5 h-2 w-2 rounded-full bg-emerald-500\" data-v-8719482a></span><strong data-v-8719482a>Book &amp; Earn:</strong> Access net rates, set agent markups, and earn loyalty points on every booking. </li></ol></div>", 3)
                    ])))
                  : _createCommentVNode("", true),
                (type.value === 'web' || type.value === 'corporate')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[12] || (_cache[12] = [
                      _createStaticVNode("<div data-v-8719482a><span class=\"inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-bold bg-blue-50 text-blue-700 border border-blue-200/50 uppercase tracking-widest\" data-v-8719482a> Premium Chauffeur Service </span><h2 class=\"text-3xl md:text-4xl font-extrabold text-slate-900 mt-4 leading-tight\" data-v-8719482a> Experience Seamless Global Travel </h2><p class=\"text-slate-600 mt-4 text-[16px] leading-relaxed\" data-v-8719482a> Vehitra World is a premium global ground transportation platform. We provide highly reliable airport transfers, point-to-point transfers, and hourly chauffeur services for discerning business and leisure travelers in hundreds of major cities. </p></div><div class=\"space-y-6\" data-v-8719482a><h3 class=\"text-xs uppercase tracking-[0.2em] font-bold text-slate-400\" data-v-8719482a>Our Customer Promise</h3><div class=\"flex gap-4\" data-v-8719482a><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-blue-50 text-blue-700 flex items-center justify-center border border-blue-100 shadow-sm\" data-v-8719482a><i class=\"pi pi-shield text-lg\" data-v-8719482a></i></div><div data-v-8719482a><h4 class=\"text-[16px] font-bold text-slate-800\" data-v-8719482a>Uncompromised Safety &amp; Quality</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\" data-v-8719482a>Every chauffeur is licensed, English-speaking, fully vetted, and drives a late-model premium vehicle.</p></div></div><div class=\"flex gap-4\" data-v-8719482a><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-blue-50 text-blue-700 flex items-center justify-center border border-blue-100 shadow-sm\" data-v-8719482a><i class=\"pi pi-clock text-lg\" data-v-8719482a></i></div><div data-v-8719482a><h4 class=\"text-[16px] font-bold text-slate-800\" data-v-8719482a>Flight Monitoring &amp; Wait Time</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\" data-v-8719482a>We track your flight in real time for delays. All airport pickups include 60 minutes of complimentary waiting time.</p></div></div><div class=\"flex gap-4\" data-v-8719482a><div class=\"shrink-0 h-12 w-12 rounded-2xl bg-blue-50 text-blue-700 flex items-center justify-center border border-blue-100 shadow-sm\" data-v-8719482a><i class=\"pi pi-ticket text-lg\" data-v-8719482a></i></div><div data-v-8719482a><h4 class=\"text-[16px] font-bold text-slate-800\" data-v-8719482a>Fixed &amp; All-Inclusive Prices</h4><p class=\"text-sm text-slate-500 mt-1 leading-relaxed\" data-v-8719482a>No hidden fees, surprise charges, or fuel/toll surcharges. The price quoted is exactly what you pay.</p></div></div></div><div class=\"bg-white border border-gray-150 rounded-2xl p-6 shadow-sm space-y-4\" data-v-8719482a><h3 class=\"text-sm uppercase tracking-wider font-bold text-slate-850\" data-v-8719482a>How it works</h3><ol class=\"relative border-l border-blue-100 ml-3 space-y-4 text-sm text-slate-600\" data-v-8719482a><li class=\"pl-4 relative\" data-v-8719482a><span class=\"absolute -left-[5px] top-1.5 h-2 w-2 rounded-full bg-blue-500\" data-v-8719482a></span><strong data-v-8719482a>Create Your Account:</strong> Save your personal information and profile preferences securely. </li><li class=\"pl-4 relative\" data-v-8719482a><span class=\"absolute -left-[5px] top-1.5 h-2 w-2 rounded-full bg-blue-500\" data-v-8719482a></span><strong data-v-8719482a>Book ground travel:</strong> Enter your pickup/dropoff points, select a vehicle, and complete the reservation. </li><li class=\"pl-4 relative\" data-v-8719482a><span class=\"absolute -left-[5px] top-1.5 h-2 w-2 rounded-full bg-blue-500\" data-v-8719482a></span><strong data-v-8719482a>Travel in comfort:</strong> Meet your professional chauffeur and reach your destination safely. </li></ol></div>", 3)
                    ])))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("header", _hoisted_11, [
                    _createElementVNode("h1", _hoisted_12, _toDisplayString(pageHeading.value), 1),
                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-slate-500 mt-1 text-[14px]" }, " Fill in your details below to get started. ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("section", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "section-title" }, "Basic information", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("label", {
                            for: "signup-fullname",
                            class: _normalizeClass(["label-upper", form.value.fullName.error ? 'text-ef-text' : 'text-slate-500'])
                          }, " Full name * ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["field-wrap", form.value.fullName.error ? 'border-ef-outline ring-ef-outline' : 'border-slate-200'])
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.fullName.value) = $event)),
                              type: "text",
                              id: "signup-fullname",
                              class: "field-input",
                              placeholder: "John Smith"
                            }, null, 512), [
                              [_vModelText, form.value.fullName.value]
                            ])
                          ], 2),
                          (form.value.fullName.error)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(form.value.fullName.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("label", {
                            for: "signup-email",
                            class: _normalizeClass(["label-upper", form.value.email.error ? 'text-ef-text' : 'text-slate-500'])
                          }, " Email * ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["field-wrap", form.value.email.error ? 'border-ef-outline ring-ef-outline' : 'border-slate-200'])
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.email.value) = $event)),
                              type: "email",
                              id: "signup-email",
                              class: "field-input",
                              placeholder: "you@example.com"
                            }, null, 512), [
                              [_vModelText, form.value.email.value]
                            ])
                          ], 2),
                          (form.value.email.error)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(form.value.email.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (type.value !== 'web')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("label", {
                                for: "signup-companyname",
                                class: _normalizeClass(["label-upper", form.value.companyName.error ? 'text-ef-text' : 'text-slate-500'])
                              }, " Company name * ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["field-wrap", form.value.companyName.error ? 'border-ef-outline ring-ef-outline' : 'border-slate-200'])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.companyName.value) = $event)),
                                  type: "text",
                                  id: "signup-companyname",
                                  class: "field-input",
                                  placeholder: "Acme LLC"
                                }, null, 512), [
                                  [_vModelText, form.value.companyName.value]
                                ])
                              ], 2),
                              (form.value.companyName.error)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(form.value.companyName.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (type.value !== 'web')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("label", {
                                for: "signup-phonenumber",
                                class: _normalizeClass(["label-upper", form.value.phone.error ? 'text-ef-text' : 'text-slate-500'])
                              }, " Phone Number * ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["field-wrap", form.value.phone.error ? 'border-ef-outline ring-ef-outline' : 'border-slate-200'])
                              }, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(CountrySearchablePhoneField, {
                                    onPhoneNumber: handlePhoneInput,
                                    class: "h-[48px] md:h-[52px] font-semibold text-[15px] px-2"
                                  })
                                ])
                              ], 2),
                              (form.value.phone.error)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(form.value.phone.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (type.value === 'agent')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("label", {
                                for: "signup-cr",
                                class: _normalizeClass(["label-upper", form.value.crNumber.error ? 'text-ef-text' : 'text-slate-500'])
                              }, " CR Number * ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["field-wrap", form.value.crNumber.error ? 'border-ef-outline ring-ef-outline' : 'border-slate-200'])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.crNumber.value) = $event)),
                                  type: "text",
                                  id: "signup-cr",
                                  class: "field-input",
                                  placeholder: "123456"
                                }, null, 512), [
                                  [_vModelText, form.value.crNumber.value]
                                ])
                              ], 2),
                              (form.value.crNumber.error)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(form.value.crNumber.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (type.value === 'agent')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("label", {
                                for: "signup-vat",
                                class: _normalizeClass(["label-upper", form.value.vat.error ? 'text-ef-text' : 'text-slate-500'])
                              }, " VAT (optional) ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["field-wrap", form.value.vat.error ? 'border-ef-outline ring-ef-outline' : 'border-slate-200'])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.vat.value) = $event)),
                                  type: "text",
                                  id: "signup-vat",
                                  class: "field-input",
                                  placeholder: "(if applicable)"
                                }, null, 512), [
                                  [_vModelText, form.value.vat.value]
                                ])
                              ], 2),
                              (form.value.vat.error)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(form.value.vat.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (type.value === 'agent')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("label", {
                                for: "signup-address",
                                class: _normalizeClass(["label-upper", form.value.address.error ? 'text-ef-text' : 'text-slate-500'])
                              }, " Address * ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["field-wrap", form.value.address.error ? 'border-ef-outline ring-ef-outline' : 'border-slate-200'])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.address.value) = $event)),
                                  type: "text",
                                  id: "signup-address",
                                  class: "field-input",
                                  placeholder: "Street, City, Country"
                                }, null, 512), [
                                  [_vModelText, form.value.address.value]
                                ])
                              ], 2),
                              (form.value.address.error)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(form.value.address.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (type.value === 'supplier')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _cache[14] || (_cache[14] = _createElementVNode("label", {
                                for: "signup-message",
                                class: "label-upper text-slate-500"
                              }, " Message * ", -1)),
                              _createElementVNode("div", _hoisted_31, [
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.message.value) = $event)),
                                  id: "signup-message",
                                  class: "field-input h-[180px] md:h-[220px] resize-y",
                                  placeholder: "Tell us more about your services…"
                                }, null, 512), [
                                  [_vModelText, form.value.message.value]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (type.value !== 'supplier')
                      ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
                          _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "section-title" }, "Security", -1)),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("label", {
                                for: "signup-password",
                                class: _normalizeClass(["label-upper", form.value.password.error ? 'text-ef-text' : 'text-slate-500'])
                              }, " Password * ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["field-wrap pr-1", form.value.password.error ? 'border-ef-outline ring-ef-outline' : 'border-slate-200'])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.password.value) = $event)),
                                  type: passwordFieldtype.value,
                                  id: "signup-password",
                                  class: "field-input",
                                  placeholder: "••••••••"
                                }, null, 8, _hoisted_35), [
                                  [_vModelDynamic, form.value.password.value]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "icon-btn",
                                  onClick: togglePasswordFieldType
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: passwordFieldtype.value === 'password' ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'
                                  }, null, 8, ["icon"])
                                ])
                              ], 2),
                              (form.value.password.error)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(form.value.password.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("label", {
                                for: "signup-password-confirmation",
                                class: _normalizeClass(["label-upper", form.value.passwordConfirmation.error ? 'text-ef-text' : 'text-slate-500'])
                              }, " Confirm Password * ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["field-wrap pr-1", form.value.passwordConfirmation.error ? 'border-ef-outline ring-ef-outline' : 'border-slate-200'])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.passwordConfirmation.value) = $event)),
                                  type: passwordFieldtype.value,
                                  id: "signup-password-confirmation",
                                  class: "field-input",
                                  placeholder: "••••••••"
                                }, null, 8, _hoisted_38), [
                                  [_vModelDynamic, form.value.passwordConfirmation.value]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "icon-btn",
                                  onClick: togglePasswordFieldType
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: passwordFieldtype.value === 'password' ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'
                                  }, null, 8, ["icon"])
                                ])
                              ], 2),
                              (form.value.passwordConfirmation.error)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(form.value.passwordConfirmation.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("section", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        (type.value !== 'supplier')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push({ name: 'Login' }))),
                              class: "order-2 md:order-1 w-full md:w-auto rounded-full px-5 md:px-7 py-3 border-2 border-slate-200 text-slate-700 hover:bg-white uppercase tracking-wide text-xs md:text-[12px] font-medium transition"
                            }, " I already have an account "))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: handleSignup,
                          disabled: isLoading.value,
                          class: "order-1 md:order-2 w-full md:w-auto rounded-full px-6 md:px-8 py-3 border-2 border-emerald-600 bg-emerald-600 text-white uppercase tracking-wide text-xs md:text-[12px] font-semibold shadow hover:bg-white hover:text-emerald-700 transition disabled:opacity-40 disabled:cursor-not-allowed"
                        }, [
                          (!isLoading.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(type.value === 'supplier' ? 'Submit' : 'Signup'), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_44, _cache[17] || (_cache[17] = [
                                _createElementVNode("svg", {
                                  class: "animate-spin",
                                  width: "16",
                                  height: "16",
                                  viewBox: "0 0 24 24",
                                  fill: "none"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M12 2a10 10 0 100 20",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round"
                                  })
                                ], -1),
                                _createTextVNode(" Processing… ")
                              ])))
                        ], 8, _hoisted_42)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mt-2 ml-auto google-recaptcha" }, null, -1)),
                        (recaptchaError.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(recaptchaError.value), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                (type.value !== 'supplier')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_47, _cache[19] || (_cache[19] = [
                      _createTextVNode(" Need help? "),
                      _createElementVNode("span", { class: "text-emerald-700" }, "Our team is available 24/7", -1),
                      _createTextVNode(". ")
                    ])))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createVNode(Notification, {
          show: notif.value.show,
          type: notif.value.type,
          message: notif.value.message,
          messageDetails: notif.value.messageDetails,
          onClosed: notifClosed
        }, null, 8, ["show", "type", "message", "messageDetails"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_48, [
        _createVNode(Notification, {
          show: notif.value.show,
          type: "error",
          message: "We do not recognize this url",
          messageDetails: "The url you are visiting is invalid and cannot be used to display anything",
          onClosed: notifClosed
        }, null, 8, ["show"])
      ]))
}
}

})